<template>
  <div class="group-booking">
    <div class="nav">
      <van-search
        style="position:fixed;top:0px;width:100%;z-index:1000;"
        v-model="searchText"
        placeholder="请输入搜索关键词"
        @search="onRefresh(searchText)"
      />
      <div class="header-silder">
        <ul class="silder-list">
          <li
            :id="'item' + index"
            v-for="(item, index) in arr"
            @click="changeTab(index, item)"
            :class="{ current: currentIndex === index }"
            :key="index"
            :style="index == arr.length-1 ? {width:'6.25rem',textAlign:'left',paddingLeft:'0.5rem'} : ''"
          >{{ item.cat_name }}</li>
        </ul>
        <div class="more" @click="shows"></div>
      </div>
    </div>
    <!-- 有内容时候的页面 -->
    <div class="wrapper" >
      <van-pull-refresh v-model="isMyLoading" @refresh="onRefresh" style="margin-bottom: 4rem;">
        <van-list
          v-model="isMyLoading"
          :finished="finished"
          finished-text="没有更多"
          @load="shopList(searchText)"
          offset="600"
          :immediate-check="false"
          ref="list"
        >
          <div
            class="detail"
            v-for="(item, index) in form"
            :key="index"
            @click="detail(item)"
            :style="index == 0 ? { marginTop: '50px' } : index == form.length-1 ? { marginBottom: '50px' } :''"
          >
            <div class="inner">
              <img :src="item.shopgroup_img" class="image" />
              <p>{{ item.shopgroup_title }}</p>
              <span>{{ item.shopgroup_projectname }}</span>
              <span>|</span>
              <span>{{ item.shopgroup_count }}人已成团</span>
              <br />
              <span class="price">¥{{ item.shopgroup_joinprice }}</span>
              <span class="oldprice">¥{{ item.shopgroup_originalprice }}</span>
              <div class="info">{{ item.shopgroup_joinnumber }}人成团</div>
              <div class="oldinfo">去拼团</div>
              <div class="tag" v-show="item.now < item.shopgroup_endtime">限时抢购中</div>
              <div class="tags" v-show="item.now > item.shopgroup_endtime">活动已结束</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 无内容时候的页面 -->
    <div class="dummy" v-show="form.length == 0"></div>
    <div class="state"  v-show="form.length == 0">暂无相关数据</div>
    <!-- 弹出层 -->
    <van-popup
      v-model="show"
      closeable
      close-icon-position="top-left"
      position="bottom"
      :style="{ height: '90%' }"
    >
      <div class="popup">
        <p class="type">考试类型选择</p>
        <ul class="mores">
          <li
            v-for="(item, index) in arr"
            @click="changeClass(index, item)"
            :class="{ currentId: currentIndex === index }"
            :key="index"
          >{{ item.cat_name }}</li>
        </ul>
      </div>
    </van-popup>
<Tabbar></Tabbar>
  </div>
</template>

<script>
	import {api_group,api_goods} from '@/common/Request.js';
	import Tabbar from '@/components/tabbar.vue';
export default {
  data() {
    return {
      searchText: "",
      maxHeight: "calc(" + window.innerHeight + "px" + " - 6rem)",
      isMyLoading: false,
      pageNo: 1,
      pageSize: 4,
      total: "",
      has_next: true,
      finished: false,
      loading: false,
      show: false,
      currentIndex: 0,
      current: 0,
      arr: [
        {
          cat_id: "",
          cat_name: "",
          sort_order: ""
        }
      ],
      sh: false,
      showing: true,
      projectid: 0,
      form: []
    };
  },
  components: {
    Tabbar
  },
  created() {
    this.getList();
  },
  mounted() {
    this.onRefresh();
  },
  // watch: {
  //   searchText(val) {
  //     this.onRefresh(val);
  //   }
  // },
  methods: {
    onRefresh(keywords) {
      this.form = [];
      this.pageNo = 1;
      this.has_next = true;
      this.shopList(keywords);
    },
    detail(item) {
      this.$router.push({
        path: "detail_page",
        query: { shopgroup_id: item.shopgroup_id }
      });
    },
    changeTab(index, item) {
      // let delta = document.getElementById("item" + index).offsetLeft;
      // document.querySelector(".silder-list").scrollTo(delta, 0);
      this.currentIndex = index;
      this.projectid = item.cat_id;
      this.onRefresh(this.searchText);
    },
    shows() {
      this.show = true;
    },
    changeClass(index, item) {
      this.show = false;
      // console.log(index,item)
      let delta = document.getElementById("item" + index).offsetLeft;
      document.querySelector(".silder-list").scrollTo(delta, 0);
      this.currentIndex = index;
      this.projectid = item.cat_id;
      this.onRefresh(this.searchText);
    },
    onLoad() {},
    getList() {
      var obj = { cat_id: "0", cat_name: "全部", sort_order: "0" };
	  api_goods.category().then(
        res => {
          // console.log(res)
          this.arr = res.data;
          this.arr.unshift(obj);
        }
      );
    },
    shopList(keywords) {
		console.log("shoplist");
      let self = this;
      self.isMyLoading = true;
      if (self.has_next) {
        if (!keywords) {
			api_group.shopgroup_list(self.pageSize,self.pageNo,self.projectid).then(res => {
              console.log('ress',res);
              const list = res.data;
              // const nowtime = new Date().valueOf();
              list.forEach(item => {
                item.shopgroup_endtime = (new Date(this.formatstr(item.shopgroup_endtime))).valueOf();
                // if ((nowtime -endtime) > 0) {
                //   this.sh = true;
                //   this.showing = false;
                // list.push(endtime)
                // }
                item.now = new Date().valueOf()
              });
              self.total = parseInt(res.msg);
              self.form = [...self.form, ...list];
              self.isMyLoading = false;
              // console.log('22',self.form );
              if (self.pageNo * self.pageSize < self.total) {
                self.has_next = true;
              } else {
                self.has_next = false;
              }
              self.pageNo++;
            });
        } else {
			api_group.shopgroup_search(self.pageSize,self.pageNo,keywords).then(res => {
              // console.log(res);
              const list = res.data;
              list.forEach(item => {
                 item.shopgroup_endtime = (new Date(this.formatstr(item.shopgroup_endtime))).valueOf();
                item.now = new Date().valueOf()
              });
               self.total = parseInt(res.msg);
              self.form = [...self.form, ...list];
              self.isMyLoading = false;
              if ((self.pageNo + 1) * self.pageSize < self.total) {
                self.has_next = true;
              } else {
                self.has_next = false;
              }
              self.pageNo++;
            });
        }
      } else {
        self.isMyLoading = false;
      }
	  console.log(this.finished);
    },
    formatstr(timestr)
    {
       timestr=timestr.replace(/-/g,"/");
       return timestr;
    }
  }
};
</script>

<style scoped>
.group-booking {
  background-color: #f3f3f3;
}


.nav {
  overflow: hidden;
  height: 2.75rem /* 44/16 */;
}
.title {
  height: 2.75rem /* 44/16 */;
  line-height: 3.125rem /* 50/16 */;
  text-align: center;
}
.header-silder {
  position: fixed;
  top: 3rem;
  height: 2.75rem /* 44/16 */;
  width: 100%;
  background: #fff;
  border-bottom: 0.01rem solid #eee;
  z-index: 1;
}
.silder-list {
  line-height: 2.75rem;
  height: 2.75rem /* 44/16 */;
  padding: 0.1rem 0.1rem;
  text-align: center;
  box-sizing: border-box;
  overflow-x: scroll;
  list-style: none;
  border-top: 0.01rem solid #eee;
  display: -webkit-box;
  overflow-y: hidden;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
.silder-list::-webkit-scrollbar {
  display: none;
}

/*定义滚动条轨道 内阴影+圆角*/
.silder-list::-webkit-scrollbar-track {
  display: none;
}

/*定义滑块 内阴影+圆角*/
.silder-list::-webkit-scrollbar-thumb {
  display: none;
}
.silder-list li {
  font-size: 0.75rem /* 12/16 */;
  /* color: #595757; */
  color: #333333;
  width: 5.2rem;
  /* font-size: 0.34rem; */
  padding: 0rem 0.24rem;
  /* color: #505050bf; */
}
.currentId {
  /* color: #1aac19 !important; */
  color: red !important;
  /* background-color: #f3fff3; */
}
.current {
  color: red !important;
  /* color: #1aac19 !important; */
  /* background-color: #f3fff3; */
}
.detail {
  width: 100%;
  height: 19.9375rem /* 319/16 */;
  background-color: #fff;
  position: relative;
  box-sizing: border-box;
  padding-top: 0.9375rem /* 15/16 */;
  margin-bottom: 0.625rem /* 10/16 */;
}
.detail .inner {
  position: relative;
  margin-left: 0.9375rem /* 15/16 */;
  margin-right: 0.9375rem;
  /*width: 21.5625rem /* 345/16 */;
}
.image {
  border: none;
  width: 100%;
  height: 12.5rem /* 200/16 */;
}
p {
  font-size: 0.875rem /* 14/16 */;
  color: #333;
  font-weight: 700;
}
span {
  font-size: .75rem /* 12/16 */;
  color: #a9a9a9;
}
.price {
  font-size: 1rem /* 15/16 */;
  color: #fe4646;
  font-weight: 700;
}
.oldprice {
  margin-left: 0.625rem /* 10/16 */;
  text-decoration: line-through;
}
.info {
  font-size: 0.5rem /* 8/16 */;
  width: 3.25rem /* 20/16 */;
  height: 1.2rem /* 10/16 */;
  border: 0.0625rem solid red;
  position: absolute;
  right: 4.1875rem /* 50/16 */;
  display: inline-block;
  line-height: 1.2rem;
  text-align: center;
}
.oldinfo {
  font-size: 0.5rem /* 8/16 */;
  width: 3.25rem /* 20/16 */;
  height: 1.2rem /* 10/16 */;
  border: 0.0625rem solid #fe5a59;
  position: absolute;
  right: 0.9375rem /* 15/16 */;
  display: inline-block;
  background-color: red;
  line-height: 1.2rem;
  text-align: center;
  color: #ffffff;
}
.footer {
  height: 3rem /* 48/16 */;
}
.tag {
  height: 1.75rem /* 28/16 */;
  width: 6.25rem /* 100/16 */;
  position: absolute;
  top: 0rem;
  left: 0rem;
  background: url("/img/biaoqian.png") no-repeat;
  background-size: 100% 100%;
  font-size: 0.6875rem /* 11/16 */;
  color: #fff;
  line-height: 1.71875rem /* 27.5/16 */;
  padding-left: 1.1875rem /* 19/16 */;
}
.tags {
  height: 1.75rem /* 28/16 */;
  width: 6.25rem /* 100/16 */;
  position: absolute;
  top: 0rem;
  left: 0rem;
  background: url("/img/biaoqian2.png") no-repeat;
  background-size: 100% 100%;
  font-size: 0.6875rem /* 11/16 */;
  color: #666666;
  line-height: 1.71875rem /* 27.5/16 */;
  padding-left: 1.1875rem /* 19/16 */;
}
.more {
  width: 2.375rem /* 38/16 */;
  height: 2.75rem /* 44/16 */;
  background-color: red;
  float: right;
  position: relative;
  top: -100%;
  background: url("/img/more.png") no-repeat;
  background-size: 100% 100%;
}
.popup {
  padding-top: 4.375rem /* 70/16 */;
  padding-left: 0.9375rem /* 15/16 */;
  padding-right: 0.9375rem /* 15/16 */;
}
.type {
  font-size: 0.875rem /* 14/16 */;
  color: #333333;
}
.popup .mores {
  margin-top: 1.3125rem /* 21/16 */;
}
.popup .mores li {
  width: 6.25rem /* 100/16 */;
  height: 1.875rem /* 30/16 */;
  border: 0.0625rem solid #cccccc;
  display: inline-block;
  text-align: center;
  line-height: 1.875rem /* 30/16 */;
  border-radius: 0.1875rem /* 3/16 */;
  margin-bottom: 1.25rem /* 20/16 */;
  margin-right: 0.92rem /* 21/16 */;
  font-size: 0.75rem /* 12/16 */;
}
.popup .mores li:nth-child(3n) {
  margin-right: 0;
}
/* 空状态 */
.dummy {
   width: 6.6875rem /* 107/16 */;
    height: 6.5rem /* 104/16 */;
    background: url('/img/kong.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 16rem;
    left:50%;
    transform:translate(-50%,-50%);
}
.state {
    position: absolute;
    width: 6.6875rem /* 107/16 */;
    height: 1.25rem /* 20/16 */;
    color: #A9A9A9;
    text-align: center;
    top: 20rem;
    left:50%;
    transform:translate(-50%,-50%);
  }
</style>
